"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCache = void 0;
const cache_1 = __importDefault(require("@emotion/cache"));
let cache = undefined;
/** Lazily initialized singleton */
function getCache() {
    if (cache === undefined) {
        cache = cache_1.default({ "key": "tss-react" });
    }
    return cache;
}
exports.getCache = getCache;
//# sourceMappingURL=cache.js.map